/* eslint-disable react/no-this-in-sfc */
/* eslint-disable func-names */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  CircularProgress,
  Collapse,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  List,
  ListItem,
  Spinner,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { FiPlus, FiMinus, FiSearch } from 'react-icons/fi';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { useFormValidationToast } from '../../../services/actionToast';
import { InputForm } from '../../inputs/forms/InputForm';
import { FormButton } from '../../buttons/FormButton';
import { ReturnButton } from '../../buttons/ReturnButton';
import { getFetchData, useFetch } from '../../../hooks/useFetch';
import { SelectInputForm } from '../../inputs/forms/SelectInputForm';
import { MaskedInputForm } from '../../inputs/forms/MaskedInputForm';
import { SwitchInputForm } from '../../inputs/forms/SwitchInputForm';
import AlertModal from '../../AlertModal';
import { PageTitle } from '../../PageTitle';
import { FormBox } from '../../formBox';
import { FormHeading } from '../../formHeading';
import { getFormattedLabel } from '../../../utils/FormatFunctions';
import { getResponsibleValidationShape } from './validation';

interface InstitutionFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: any;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function InstitutionForm({ defaultValues }: InstitutionFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/institutions';
  const { requestApi: reqApiInstitutions, error: errorInstitutions } = useFetch(baseUrl, {
    actionFeedback: false,
  });
  const {
    requestApi: reqApiSecretaries,
    data: dataSecretaries,
    loading: loadingSecretaries,
  } = useFetch('/v1/admin/secretaries');
  const {
    requestApi: reqApiModules,
    data: dataModules,
    loading: loadingModules,
  } = useFetch('/v1/admin/material-modules');
  const { requestApi: reqApiUsers } = useFetch('/v1/admin/users');
  const { data: optionsSecretaries, pagination: paginationSecretaries } =
    getFetchData(dataSecretaries);
  const { requestApi: reqApiCodepost, error: errorCodepost } = useFetch('/v1/client/address');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { itemId } = useParams();
  const navigate = useNavigate();
  const [loadingCodepost, setLoadingCodepost] = useState<any>(false);
  const [address, setAddress] = useState<any>({});
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [moduleDetails, setModuleDetails] = useState<any>(null);
  const [selectedExistingUsers, setSelectedExistingUsers] = useState<any[]>([]);
  const [userSearchResults, setUserSearchResults] = useState<any[]>([]);
  const [isSearchingUsers, setIsSearchingUsers] = useState(false);
  const [showNewUserFields, setShowNewUserFields] = useState(true);
  const [eligibleUsers, setEligibleUsers] = useState<any[]>([]);
  const [loadingEligibleUsers, setLoadingEligibleUsers] = useState(false);

  const optionsType = [
    {
      label: 'Pública',
      value: 'PUBLICA',
    },
    {
      label: 'Privada',
      value: 'PRIVADA',
    },
  ];

  const templateStrategyOptions = [
    {
      label: 'Aplicar template padrão',
      value: 'DEFAULT',
    },
    {
      label: 'Aplicar template manualmente depois',
      value: 'MANUAL',
    },
  ];

  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'name',
      value: defaultValues?.name ?? '',
      placeholder: 'Nome da instituição',
      label: 'Nome',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'secretary_id',
      value: defaultValues?.secretary ? getFormattedLabel(defaultValues?.secretary) : null,
      placeholder: 'Selecione uma secretaria ou "Sem Secretaria"',
      label: 'Qual secretaria?',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'template_strategy',
      value: defaultValues?.template_strategy
        ? templateStrategyOptions.find((item) => item.value === defaultValues.template_strategy)
        : templateStrategyOptions.find((item) => item.value === 'DEFAULT'), // Mudado de MANUAL para DEFAULT
      placeholder: 'Selecione uma opção',
      label: 'Qual template deseja aplicar?',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'module_id',
      value: defaultValues?.module_id
        ? {
            label:
              defaultValues?.module?.name && defaultValues.module.name.trim() !== ''
                ? defaultValues.module.name
                : `Módulo ${defaultValues.module_id}`,
            value: defaultValues.module_id,
          }
        : null,
      placeholder: 'Selecione um template personalizado',
      label: 'Templates personalizados',
      yup: Yup.mixed(),
    },
    {
      name: 'site',
      value: defaultValues?.site ?? '',
      placeholder: 'Site da instituição',
      label: 'Site',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'type',
      value: defaultValues?.type
        ? optionsType.find((item) => item.value === defaultValues?.type)
        : null,
      placeholder: 'Tipo de instituição',
      label: 'Tipo',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'cell_phone',
      value: defaultValues?.cell_phone ?? '',
      placeholder: 'Telefone da instituição',
      label: 'Telefone',
      yup: Yup.string(),
    },
    {
      name: 'code_post',
      value: defaultValues?.address?.code_post ?? '',
      placeholder: 'CEP da instituição',
      label: 'CEP',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_id',
      value: defaultValues?.address?.city?.id ?? '',
      placeholder: '',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_name',
      value: defaultValues?.address?.city?.name ?? '',
      placeholder: 'Cidade da instituição',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'state_name',
      value: defaultValues?.address?.city?.state?.name ?? '',
      placeholder: 'Estado da instituição',
      label: 'Estado',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'street',
      value: defaultValues?.address?.street ?? '',
      placeholder: 'Rua da instituição',
      label: 'Rua',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'number',
      value: defaultValues?.address?.number ?? '',
      placeholder: 'Número da instituição',
      label: 'Número',
      yup: Yup.string(),
    },
    {
      name: 'district',
      value: defaultValues?.address?.district ?? '',
      placeholder: 'Bairro da instituição',
      label: 'Bairro',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'complement',
      value: defaultValues?.address?.complement ?? '',
      placeholder: 'Complemento da instituição',
      label: 'Complemento',
      yup: Yup.string(),
    },
    {
      name: 'responsible',
      value: defaultValues?.responsible ?? '',
      placeholder: 'Nome do responsável',
      label: 'Nome',
      yup: Yup.string(),
    },
    {
      name: 'email',
      value: defaultValues?.email ?? '',
      placeholder: 'Email do responsável',
      label: 'Email',
      yup: Yup.string().email('Email inválido'),
    },
    {
      name: 'responsible_phone',
      value: defaultValues?.responsible_phone ?? '',
      placeholder: 'Telefone do responsável',
      label: 'Telefone',
      yup: Yup.string(),
    },
    {
      name: 'function',
      value: defaultValues?.function ?? 'Responsável pela instituição',
      placeholder: 'Função do responsável',
      label: 'Função',
      yup: Yup.string(),
    },
    {
      name: 'status',
      value: defaultValues?.status ?? true,
      label: 'Status',
      yup: Yup.boolean(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });

  // Calcula se há responsáveis existentes selecionados
  const hasExistingResponsibles = selectedExistingUsers.length > 0;

  // Schema dinâmico: se há usuários existentes selecionados, os campos de novo responsável não são obrigatórios
  // IMPORTANTE: useMemo com dependência de hasExistingResponsibles para recriar schema quando mudar
  const schema = useMemo(
    () =>
      Yup.object().shape({
        ...yupschema,
        ...getResponsibleValidationShape(),
      }),
    [hasExistingResponsibles]
  );

  const moduleItems = useMemo(() => {
    if (!dataModules) return [];
    const response = getFetchData(dataModules);
    if (Array.isArray(response?.data)) return response.data;
    if (Array.isArray(dataModules)) return dataModules as any[];
    return [];
  }, [dataModules]);

  const moduleOptions = useMemo(
    () =>
      moduleItems.map((item: any) => ({
        label: item?.name && item.name.trim() !== '' ? item.name : `Módulo ${item?.id}`,
        value: item?.id,
      })),
    [moduleItems]
  );

  const defaultModuleOption = useMemo(() => {
    const defaultModule = moduleItems.find((item: any) => item?.is_default);
    if (!defaultModule) return null;
    return {
      label:
        defaultModule?.name && defaultModule.name.trim() !== ''
          ? defaultModule.name
          : `Módulo ${defaultModule?.id}`,
      value: defaultModule?.id,
    };
  }, [moduleItems]);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    control,
    trigger,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema, { context: { hasExistingUsers: hasExistingResponsibles } }),
    defaultValues: defaultValuesSchema,
  });

  const name = formInputs.find((field) => field.name === 'name');
  const secretary = formInputs.find((field) => field.name === 'secretary_id');
  const templateStrategy = formInputs.find((field) => field.name === 'template_strategy');
  const moduleField = formInputs.find((field) => field.name === 'module_id');
  const cellphone = formInputs.find((field) => field.name === 'cell_phone');
  const site = formInputs.find((field) => field.name === 'site');
  const type = formInputs.find((field) => field.name === 'type');
  const codePost = formInputs.find((field) => field.name === 'code_post');
  const city = formInputs.find((field) => field.name === 'city_name');
  const state = formInputs.find((field) => field.name === 'state_name');
  const street = formInputs.find((field) => field.name === 'street');
  const number = formInputs.find((field) => field.name === 'number');
  const district = formInputs.find((field) => field.name === 'district');
  const complement = formInputs.find((field) => field.name === 'complement');
  const responsible = formInputs.find((field) => field.name === 'responsible');
  const responsibleEmail = formInputs.find((field) => field.name === 'email');
  const responsiblePhone = formInputs.find((field) => field.name === 'responsible_phone');
  const responsibleFunction = formInputs.find((field) => field.name === 'function');
  const status = formInputs.find((field) => field.name === 'status');
  const templateStrategyValue = watch('template_strategy');
  const moduleSelectedValue = watch('module_id');
  const isDefaultTemplateSelected =
    templateStrategyValue?.value === 'DEFAULT' || templateStrategyValue === 'DEFAULT';
  const isEditing = Boolean(itemId);

  // Função para recarregar responsáveis vinculados
  const reloadResponsibles = React.useCallback(async () => {
    if (!itemId) return;

    try {
      const response = await reqApiUsers(
        'get',
        {},
        `/v1/admin/institutions/${itemId}/additional-responsibles`
      );
      if (response?.data?.data && Array.isArray(response.data.data)) {
        setSelectedExistingUsers((prev) => mergeUniqueUsers([...prev, ...response.data.data]));
      }
    } catch {
      setSelectedExistingUsers([]);
    }
  }, [itemId, reqApiUsers]);

  const onSubmit = async (values: any) => {
    const templateStrategyValueNormalized =
      values.template_strategy?.value ?? values.template_strategy ?? 'MANUAL';
    const resolvedModuleId =
      templateStrategyValueNormalized === 'DEFAULT'
        ? values.module_id?.value ?? defaultModuleOption?.value ?? null
        : null;

    const params = {
      ...values,
      type: values.type.value,
      // Se secretary_id for 0 (sem secretaria), enviar null
      secretary_id: values.secretary_id?.value === 0 ? null : values.secretary_id?.value ?? null,
      template_strategy: templateStrategyValueNormalized,
      module_id: resolvedModuleId,
      // Se selecionou usuários existentes, enviar os IDs
      ...(selectedExistingUsers.length > 0
        ? {
            existing_user_ids: selectedExistingUsers.map((u) => u.id),
          }
        : {}),
      address: {
        code_post: values.code_post,
        city_id: Number(values.city_id),
        street: values.street,
        number: values.number,
        district: values.district,
        complement: values.complement,
      },
      code_post: _,
      city_id: _,
      city_name: _,
      state_name: _,
      street: _,
      number: _,
      district: _,
      complement: _,
    };
    const { status: resStatus } = await reqApiInstitutions(
      defaultValues?.name ? 'put' : 'post',
      params,
      defaultValues?.name ? `${baseUrl}/${itemId}` : null
    );

    // Recarregar responsáveis após salvar com sucesso
    if (resStatus === 200 || resStatus === 201) {
      await reloadResponsibles();
    }

    onOpen();
  };

  const getCep = async (cep) => {
    const { data, status: statusRes } = await reqApiCodepost('get', { params: { code_post: cep } });
    if (statusRes === 200) {
      setAddress(data?.data);
    } else {
      setAddress({});
    }
    setLoadingCodepost(false);
  };

  // Hook para buscar usuários com filtro
  const { requestApi: reqApiUserSearch } = useFetch('/v1/admin/users/search');

  // Buscar usuários existentes para vincular como responsável
  const searchUsers = useMemo(
    () =>
      _.debounce(async (searchTerm: string, secretaryId: number | null) => {
        if (!searchTerm || searchTerm.length < 3) {
          setUserSearchResults([]);
          return;
        }

        setIsSearchingUsers(true);

        try {
          const params: any = { q: searchTerm, exclude_responsible: true };

          if (secretaryId) {
            params.secretary_id = secretaryId;
          }

          const { data, status: statusRes } = await reqApiUserSearch('get', { params });

          if (statusRes === 200) {
            setUserSearchResults(data?.data || []);
          } else {
            setUserSearchResults([]);
          }
        } catch {
          setUserSearchResults([]);
        } finally {
          setIsSearchingUsers(false);
        }
      }, 500),
    [reqApiUserSearch]
  );

  // Handler para selecionar usuário existente (permite múltiplos)
  const mergeUniqueUsers = (users: any[]) => {
    const unique = new Map();
    users.forEach((user) => {
      if (user && user.id) {
        unique.set(user.id, {
          id: user.id,
          name: user.name,
          email: user.email,
          cell_phone: user.cell_phone,
        });
      }
    });
    return Array.from(unique.values());
  };

  const handleSelectExistingUser = (user: any) => {
    setSelectedExistingUsers((prev) => mergeUniqueUsers([...prev, user]));
    setShowNewUserFields(false);
    setUserSearchResults([]);
  };

  // Handler para remover usuário da seleção
  const handleRemoveExistingUser = (userId: number) => {
    setSelectedExistingUsers((prev) => {
      const updated = prev.filter((u) => u.id !== userId);
      if (updated.length === 0) {
        setShowNewUserFields(true);
        setValue('responsible', '');
        setValue('email', '');
        setValue('responsible_phone', '');
      }
      return updated;
    });
  };

  // Handler para limpar todas as seleções
  const handleClearAllExistingUsers = () => {
    setSelectedExistingUsers([]);
    setShowNewUserFields(true);
    setValue('responsible', '');
    setValue('email', '');
    setValue('responsible_phone', '');
  };

  // Handler para busca de usuários
  const handleUserSearch = (e: any) => {
    const searchTerm = e.target.value;

    const selectedSecretary = watch('secretary_id');
    // Se for 0 (sem secretaria), passar null para buscar todos
    const secretaryId = selectedSecretary?.value === 0 ? null : selectedSecretary?.value || null;

    searchUsers(searchTerm, secretaryId);
  };

  useEffect(() => {
    if (defaultValues?.name) {
      reset(defaultValuesSchema);
      getCep(watch('code_post').replace(/\D/g, ''));
    }
  }, [defaultValues]);

  useEffect(() => {
    reqApiModules('get');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (defaultValues?.module_id && moduleOptions.length > 0) {
      const selectedModule = moduleOptions.find(
        (option) => option.value === defaultValues.module_id
      );
      if (selectedModule) {
        setValue('module_id', selectedModule);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues?.module_id, moduleOptions]);

  useEffect(() => {
    setValue('city_id', address?.city?.id);
    setValue('city_name', address?.city?.name);
    setValue('state_name', address?.city?.state?.name);
    setValue('street', address?.street);
    setValue('district', address?.district);
  }, [address]);

  useEffect(() => {
    if (watch('code_post').replace(/\D/g, '').length < 8) {
      setAddress(null);
      return;
    }
    if (!isFirstRender) {
      setLoadingCodepost(true);
      const timeout = setTimeout(() => {
        getCep(watch('code_post').replace(/\D/g, ''));
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [watch('code_post')]);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  useEffect(() => {
    // Quando DEFAULT está selecionado, limpa o module_id (não precisa)
    if (isDefaultTemplateSelected) {
      setValue('module_id', null);
    }
    // Quando MANUAL, limpa também inicialmente
    else if (!moduleSelectedValue) {
      setValue('module_id', null);
    }
  }, [isDefaultTemplateSelected, setValue]);

  // Buscar detalhes do módulo selecionado (apenas para modo MANUAL)
  useEffect(() => {
    if (!moduleSelectedValue?.value || isDefaultTemplateSelected) {
      setModuleDetails(null);
      return;
    }

    // Buscar módulo selecionado dos dados já carregados
    const selectedModule = moduleItems.find((m: any) => m.id === moduleSelectedValue.value);
    if (selectedModule) {
      setModuleDetails(selectedModule);
    }
  }, [moduleSelectedValue, isDefaultTemplateSelected, moduleItems]);

  useEffect(() => {
    if (isEditing && itemId) {
      const loadResponsibles = async () => {
        try {
          const additional = await reqApiUsers(
            'get',
            {},
            `/v1/admin/institutions/${itemId}/additional-responsibles`
          );

          if (additional?.data?.data && Array.isArray(additional.data.data)) {
            setSelectedExistingUsers((prev) =>
              mergeUniqueUsers([...prev, ...additional.data.data])
            );
            if (additional.data.data.length > 0) {
              setShowNewUserFields(false);
            }
          }
        } catch {
          setSelectedExistingUsers([]);
        }
      };

      loadResponsibles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditing, itemId]);

  useEffect(() => {
    if (isEditing && defaultValues?.responsible_user) {
      setSelectedExistingUsers((prev) =>
        mergeUniqueUsers([...prev, defaultValues.responsible_user])
      );
      setShowNewUserFields(false);
    }
  }, [isEditing, defaultValues?.responsible_user]);

  // Revalidar formulário quando selectedExistingUsers mudar
  // Isso atualiza o context do schema de validação
  // IMPORTANTE: Só revalidar se o formulário já foi tocado (após primeira interação)
  useEffect(() => {
    // Não acionar validação no primeiro render (isFirstRender ainda é true)
    // Só revalidar após o usuário já ter interagido com o formulário
    if (trigger && !isFirstRender && selectedExistingUsers.length >= 0) {
      trigger(['responsible', 'email', 'responsible_phone', 'function']);
    }
  }, [selectedExistingUsers.length, trigger, isFirstRender]);

  // Carregar lista de usuários elegíveis para responsável de instituição
  useEffect(() => {
    const loadEligibleUsers = async () => {
      setLoadingEligibleUsers(true);
      try {
        // TODO: Melhorar backend para filtrar usuários já vinculados a outras instituições
        // Buscar usuários com group_id=7 (Responsável pela Instituição)
        const params = {
          group_id: 7,
          per_page: 50, // Limitar resultados
        };
        const response = await reqApiUsers('get', { params });
        const users = response?.data?.data || [];

        // Por enquanto, exibir todos os usuários com group_id=7
        // Futuramente, filtrar aqui os que já estão em outras instituições
        setEligibleUsers(users);
      } catch {
        setEligibleUsers([]);
      } finally {
        setLoadingEligibleUsers(false);
      }
    };

    loadEligibleUsers();
  }, []);

  return (
    <FormBox>
      <Flex>
        <ReturnButton previousPage="institutions/list" mb={5} />
        <PageTitle>{defaultValues?.name ? 'Editar' : 'Criar'} Instituição</PageTitle>
      </Flex>

      <AlertModal
        alertMsg={
          <Text textAlign="center" fontWeight="bold" fontSize="25px">
            {!errorInstitutions
              ? `Instituição ${defaultValues?.name ? 'editada' : 'criada'} com sucesso!`
              : errorInstitutions?.msg}
          </Text>
        }
        msgStatus={errorInstitutions ? 'error' : 'success'}
        closeOnOverlayClick={!!errorInstitutions}
        useSecondaryActions
        isOpenSecondary={isOpen}
        onCloseSecondary={onClose}
        ConfirmButton={
          <Button
            w="250px"
            boxShadow="0px 5px 10px #00000065"
            borderRadius="full"
            onClick={() => navigate('/institutions/list')}
          >
            Retornar para a listagem
          </Button>
        }
      />

      <form noValidate onSubmit={handleSubmit(onSubmit, validationToast)}>
        <FormHeading>Informações Básicas</FormHeading>
        <Flex gap={5}>
          <Box flex={1}>
            <InputForm
              name={name?.name}
              label={name?.label}
              placeholder={name?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <SelectInputForm
              name={type?.name}
              label={type?.label}
              options={optionsType}
              placeholder={type?.placeholder}
              isRequired
              control={control}
              errors={errors}
            />
          </Box>
        </Flex>

        <Flex gap={5} flexWrap="wrap">
          <Box flex={2} minW="240px">
            <SelectInputForm
              name={secretary?.name}
              label={secretary?.label}
              options={[
                { label: '⚠️ Sem Secretaria (Instituição Independente)', value: 0 },
                ...(optionsSecretaries?.map((item) => getFormattedLabel(item)) ?? []),
              ]}
              isLoading={loadingSecretaries}
              pagination={paginationSecretaries}
              getOptions={(filters) => reqApiSecretaries('get', { params: { ...filters } })}
              placeholder={secretary?.placeholder}
              control={control}
              errors={errors}
              isRequired
            />
          </Box>

          <Box flex={2} minW="240px">
            <SelectInputForm
              name={templateStrategy?.name}
              label={templateStrategy?.label}
              options={templateStrategyOptions}
              placeholder={templateStrategy?.placeholder}
              control={control}
              errors={errors}
              isRequired
            />
          </Box>

          {!isDefaultTemplateSelected && templateStrategyValue?.value === 'MANUAL' && (
            <Box flex={2} minW="240px">
              <SelectInputForm
                name={moduleField?.name}
                label={moduleField?.label}
                options={moduleOptions}
                isLoading={loadingModules}
                placeholder={moduleField?.placeholder}
                control={control}
                errors={errors}
              />
              {moduleSelectedValue && (
                <Box mt={2}>
                  <details>
                    <summary
                      style={{
                        cursor: 'pointer',
                        color: '#3182ce',
                        fontSize: '14px',
                        fontWeight: '500',
                      }}
                    >
                      📋 Veja o que contempla neste módulo
                    </summary>
                    <Box
                      mt={2}
                      p={4}
                      bg="blue.50"
                      borderRadius="md"
                      fontSize="sm"
                      border="1px solid"
                      borderColor="blue.200"
                    >
                      {moduleDetails ? (
                        <>
                          <Text fontWeight="bold" mb={3} color="blue.800" fontSize="md">
                            {moduleSelectedValue.label}
                          </Text>

                          {moduleDetails.description && (
                            <Text fontSize="sm" color="gray.700" mb={3}>
                              {moduleDetails.description}
                            </Text>
                          )}

                          <Box mb={3} p={3} bg="white" borderRadius="md" boxShadow="sm">
                            <Text fontWeight="semibold" mb={2} color="gray.700">
                              📊 Informações deste template:
                            </Text>
                            <Flex direction="column" gap={2}>
                              <Flex align="center" gap={2}>
                                <Text fontWeight="bold" color="blue.600" fontSize="lg">
                                  {moduleDetails.templates_count || 0}
                                </Text>
                                <Text fontSize="xs" color="gray.600">
                                  Templates de materiais vinculados
                                </Text>
                              </Flex>
                              <Flex align="center" gap={2}>
                                <Text fontWeight="bold" color="green.600" fontSize="lg">
                                  {moduleDetails.institutions_count || 0}
                                </Text>
                                <Text fontSize="xs" color="gray.600">
                                  Instituições já utilizando este módulo
                                </Text>
                              </Flex>
                              {moduleDetails.is_default && (
                                <Flex
                                  align="center"
                                  gap={2}
                                  p={2}
                                  bg="yellow.50"
                                  borderRadius="md"
                                  border="1px solid"
                                  borderColor="yellow.300"
                                >
                                  <Text fontSize="xs" fontWeight="bold" color="yellow.700">
                                    ⭐ Este é o módulo padrão recomendado
                                  </Text>
                                </Flex>
                              )}
                            </Flex>
                          </Box>

                          {moduleOptions.length > 1 && (
                            <Box p={3} bg="gray.50" borderRadius="md" fontSize="xs">
                              <Text fontWeight="semibold" mb={2} color="gray.700">
                                🔄 Comparado aos outros templates disponíveis:
                              </Text>
                              <Flex direction="column" gap={1.5}>
                                {moduleOptions
                                  .filter((opt) => opt.value !== moduleSelectedValue.value)
                                  .slice(0, 4)
                                  .map((opt) => {
                                    const otherModule = moduleItems.find(
                                      (m: any) => m.id === opt.value
                                    );
                                    return (
                                      <Flex
                                        key={opt.value}
                                        align="center"
                                        justify="space-between"
                                        p={2}
                                        bg="white"
                                        borderRadius="sm"
                                      >
                                        <Text color="gray.700" fontWeight="medium" fontSize="xs">
                                          {opt.label || `Módulo ${opt.value}`}
                                        </Text>
                                        <Flex gap={3} fontSize="xs">
                                          <Text color="blue.600">
                                            <strong>{otherModule?.templates_count || 0}</strong>{' '}
                                            templates
                                          </Text>
                                          <Text color="green.600">
                                            <strong>{otherModule?.institutions_count || 0}</strong>{' '}
                                            inst.
                                          </Text>
                                        </Flex>
                                      </Flex>
                                    );
                                  })}
                                {moduleOptions.length > 5 && (
                                  <Text fontSize="xs" color="gray.500" fontStyle="italic" mt={1}>
                                    + {moduleOptions.length - 5} outros templates disponíveis
                                  </Text>
                                )}
                              </Flex>
                            </Box>
                          )}

                          <Box mt={3} p={2} bg="blue.100" borderRadius="md">
                            <Text fontSize="xs" color="blue.800" fontWeight="medium">
                              💡 <strong>O que são Templates?</strong>
                            </Text>
                            <Text fontSize="xs" color="blue.700" mt={1}>
                              Os templates contêm Conteúdos {'>'} Categorias de materiais, tópicos,
                              avaliações e materiais extras. Você terá{' '}
                              {moduleDetails.templates_count || 0} template(s) para revisar e ativar
                              após criar a instituição.
                            </Text>
                          </Box>

                          <Text fontSize="xs" color="gray.600" mt={3} fontStyle="italic">
                            📝 Após concluir o cadastro, acesse a tela{' '}
                            <Text as="span" fontWeight="bold">
                              Vincular Templates
                            </Text>{' '}
                            para revisar e ativar/desativar os itens desejados individualmente.
                          </Text>
                        </>
                      ) : (
                        <Text fontSize="xs" color="gray.600">
                          Selecione um template para ver os detalhes...
                        </Text>
                      )}
                    </Box>
                  </details>
                </Box>
              )}
            </Box>
          )}

          {isDefaultTemplateSelected && (
            <Box flexBasis="100%">
              <Alert borderRadius="10px" status="info">
                <AlertIcon />
                <Box>
                  <Text fontWeight="bold" mb={1}>
                    ✅ Template padrão será aplicado automaticamente
                  </Text>
                  <Text fontSize="sm">
                    A seed completa de materiais, categorias e conteúdos será vinculada à
                    instituição. Você poderá revisar e ajustar os itens na tela{' '}
                    <Text
                      as="a"
                      href="/institutions/templates"
                      target="_blank"
                      rel="noopener noreferrer"
                      color="blue.600"
                      fontWeight="bold"
                      textDecoration="underline"
                    >
                      Vincular Templates
                    </Text>{' '}
                    após concluir o cadastro.
                  </Text>
                </Box>
              </Alert>
            </Box>
          )}

          {!isDefaultTemplateSelected && templateStrategyValue?.value === 'MANUAL' && (
            <Box flexBasis="100%">
              <Alert borderRadius="10px" status="warning">
                <AlertIcon />
                <Box>
                  <Text fontWeight="bold" mb={1}>
                    ⚠️ Vinculação manual de templates
                  </Text>
                  <Text fontSize="sm">
                    {moduleSelectedValue
                      ? `Você selecionou "${moduleSelectedValue.label}" como template personalizado. `
                      : 'Selecione um template personalizado acima ou '}
                    Você precisará configurar manualmente os materiais e categorias na tela{' '}
                    <Text
                      as="a"
                      href="/institutions/templates"
                      target="_blank"
                      rel="noopener noreferrer"
                      color="orange.700"
                      fontWeight="bold"
                      textDecoration="underline"
                    >
                      Vincular Templates
                    </Text>{' '}
                    após criar a instituição.
                  </Text>
                </Box>
              </Alert>
            </Box>
          )}

          <Box flex={2} minW="240px">
            <MaskedInputForm
              name={cellphone?.name}
              label={cellphone?.label}
              placeholder={cellphone?.placeholder}
              control={control}
              errors={errors}
              mask="(99) 99999-9999"
            />
          </Box>

          <Box flex={2} minW="240px">
            <InputForm
              name={site?.name}
              label={site?.label}
              placeholder={site?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>

          <Box flex={1} minW="200px">
            <SwitchInputForm
              name={status?.name}
              label={status?.label}
              errors={errors}
              control={control}
            />
          </Box>
        </Flex>

        <FormHeading>Endereço</FormHeading>

        <Flex gap={5}>
          <Box flex={1}>
            <MaskedInputForm
              name={codePost?.name}
              label={codePost?.label}
              placeholder={codePost?.placeholder}
              control={control}
              errors={errors}
              mask="99999-999"
              isRequired
            />
            {errorCodepost?.status === 404 && (
              <Flex mt={5} mb={5}>
                <Alert borderRadius="10px" status="error">
                  <AlertIcon />
                  {errorCodepost?.msg}
                </Alert>
              </Flex>
            )}
            {loadingCodepost && (
              <Flex mt={5} mb={5}>
                <Alert borderRadius="10px" status="info" gap={5}>
                  <CircularProgress isIndeterminate size="25px" />
                  Buscando CEP
                </Alert>
              </Flex>
            )}
          </Box>
          <Box flex={1}>
            <InputForm
              name={city?.name}
              label={city?.label}
              placeholder={city?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <InputForm
              name={state?.name}
              label={state?.label}
              placeholder={state?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
        </Flex>

        <Flex gap={5}>
          <Box flex={2}>
            <InputForm
              name={street?.name}
              label={street?.label}
              placeholder={street?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <InputForm
              name={number?.name}
              label={number?.label}
              placeholder={number?.placeholder}
              type="number"
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={2}>
            <InputForm
              name={district?.name}
              label={district?.label}
              placeholder={district?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={2}>
            <InputForm
              name={complement?.name}
              label={complement?.label}
              placeholder={complement?.placeholder}
              register={register}
              errors={errors}
            />
          </Box>
        </Flex>

        <FormHeading>Responsável</FormHeading>

        {/* WEB-05: Exibir dados do responsável principal na edição */}
        {itemId && defaultValues?.responsible_user && (
          <Box mb={6} p={4} bg="blue.50" borderRadius="md" borderWidth="1px" borderColor="blue.200">
            <Text fontSize="sm" fontWeight="bold" mb={3} color="blue.800">
              Responsável Principal da Instituição
            </Text>
            <Flex direction="column" gap={2}>
              <Flex align="center">
                <Text fontSize="sm" fontWeight="medium" minW="100px">
                  Nome:
                </Text>
                <Text fontSize="sm">{defaultValues.responsible_user.name || '-'}</Text>
              </Flex>
              <Flex align="center">
                <Text fontSize="sm" fontWeight="medium" minW="100px">
                  Email:
                </Text>
                <Text fontSize="sm">{defaultValues.responsible_user.email || '-'}</Text>
              </Flex>
              <Flex align="center">
                <Text fontSize="sm" fontWeight="medium" minW="100px">
                  Telefone:
                </Text>
                <Text fontSize="sm">{defaultValues.responsible_user.cell_phone || '-'}</Text>
              </Flex>
            </Flex>
          </Box>
        )}

        {/* Campo de busca de usuário existente */}
        <Box mb={6} p={4} bg="gray.50" borderRadius="md">
          <Text fontSize="sm" fontWeight="medium" mb={2}>
            Buscar responsáveis de instituição existente
          </Text>
          <Text fontSize="xs" color="gray.600" mb={3}>
            Digite pelo menos 3 caracteres para buscar e adicionar múltiplos responsáveis
          </Text>

          {!watch('secretary_id') && (
            <Alert status="info" mb={3} borderRadius="md" size="sm">
              <AlertIcon />
              <Text fontSize="xs">
                Selecione uma secretaria ou &quot;Sem Secretaria&quot; acima para habilitar a busca
              </Text>
            </Alert>
          )}

          <InputGroup>
            <InputLeftElement pointerEvents="none">
              {isSearchingUsers ? <Spinner size="sm" /> : <Icon as={FiSearch} color="gray.400" />}
            </InputLeftElement>
            <Input
              placeholder="Digite nome ou email do usuario..."
              onChange={handleUserSearch}
              bg="white"
              disabled={!watch('secretary_id')}
              autoComplete="off"
            />
          </InputGroup>

          {/* Resultados da busca */}
          {userSearchResults.length > 0 && (
            <List
              spacing={2}
              mt={3}
              maxH="200px"
              overflowY="auto"
              border="1px"
              borderColor="gray.200"
              borderRadius="md"
              bg="white"
            >
              {userSearchResults
                .filter((user) => !selectedExistingUsers.find((u) => u.id === user.id))
                .map((user) => (
                  <ListItem
                    key={user.id}
                    p={3}
                    cursor="pointer"
                    _hover={{ bg: 'blue.50' }}
                    onClick={() => handleSelectExistingUser(user)}
                    borderBottom="1px"
                    borderColor="gray.100"
                  >
                    <Flex justify="space-between" align="center">
                      <Box>
                        <Text fontWeight="medium" fontSize="sm">
                          {user.name}
                        </Text>
                        <Text fontSize="xs" color="gray.600">
                          {user.email}
                        </Text>
                        {user.cell_phone && (
                          <Text fontSize="xs" color="gray.500">
                            {user.cell_phone}
                          </Text>
                        )}
                      </Box>
                      {user.is_institution_responsible && (
                        <Tag size="sm" colorScheme="orange">
                          Já é responsável
                        </Tag>
                      )}
                    </Flex>
                  </ListItem>
                ))}
            </List>
          )}

          {/* Lista de usuários elegíveis (pré-carregada) */}
          {!isSearchingUsers && userSearchResults.length === 0 && eligibleUsers.length > 0 && (
            <Box mt={4}>
              <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
                Responsáveis de instituição disponíveis (
                {
                  eligibleUsers.filter(
                    (user) => !selectedExistingUsers.find((u) => u.id === user.id)
                  ).length
                }
                )
              </Text>
              <List
                spacing={2}
                borderWidth="1px"
                borderRadius="md"
                maxH="300px"
                overflowY="auto"
                p={2}
                bg="gray.50"
              >
                {eligibleUsers
                  .filter((user) => !selectedExistingUsers.find((u) => u.id === user.id))
                  .map((user) => (
                    <ListItem
                      key={user.id}
                      p={2}
                      borderRadius="md"
                      bg="white"
                      _hover={{ bg: 'blue.50', cursor: 'pointer', borderColor: 'blue.300' }}
                      borderWidth="1px"
                      borderColor="gray.200"
                      onClick={() => handleSelectExistingUser(user)}
                    >
                      <Text fontSize="sm" fontWeight="medium">
                        {user.name}
                      </Text>
                      <Text fontSize="xs" color="gray.600">
                        {user.email}
                      </Text>
                      {user.cell_phone && (
                        <Text fontSize="xs" color="gray.500">
                          {user.cell_phone}
                        </Text>
                      )}
                    </ListItem>
                  ))}
              </List>
            </Box>
          )}

          {loadingEligibleUsers && !isSearchingUsers && (
            <Flex mt={3} align="center" gap={2}>
              <Spinner size="sm" />
              <Text fontSize="sm" color="gray.600">
                Carregando responsáveis disponíveis...
              </Text>
            </Flex>
          )}

          {/* Usuários selecionados */}
          {selectedExistingUsers.length > 0 && (
            <Box mt={3}>
              <Flex justify="space-between" align="center" mb={2}>
                <Text fontWeight="bold" fontSize="sm">
                  {selectedExistingUsers.length} responsável(is) selecionado(s)
                </Text>
                <Button
                  size="xs"
                  colorScheme="red"
                  variant="ghost"
                  onClick={handleClearAllExistingUsers}
                >
                  Limpar todos
                </Button>
              </Flex>

              <Flex gap={2} flexWrap="wrap">
                {selectedExistingUsers.map((user) => (
                  <Tag key={user.id} size="lg" colorScheme="blue" borderRadius="full">
                    <TagLabel>
                      <Text fontSize="sm" fontWeight="medium">
                        {user.name}
                      </Text>
                      <Text fontSize="xs" color="gray.600">
                        {user.email}
                      </Text>
                    </TagLabel>
                    <TagCloseButton onClick={() => handleRemoveExistingUser(user.id)} />
                  </Tag>
                ))}
              </Flex>
            </Box>
          )}

          {/* Botao para criar novo usuario */}
          {selectedExistingUsers.length === 0 && !itemId && (
            <Button
              size="sm"
              colorScheme="blue"
              variant="outline"
              mt={3}
              onClick={() => setShowNewUserFields(!showNewUserFields)}
              leftIcon={showNewUserFields ? <Icon as={FiMinus} /> : <Icon as={FiPlus} />}
            >
              {showNewUserFields ? 'Ocultar campos de novo usuario' : 'Criar novo usuario'}
            </Button>
          )}
        </Box>

        {/* Campos de novo responsavel (colapsaveis) - apenas na criacao */}
        {!itemId && (
          <Collapse in={showNewUserFields && selectedExistingUsers.length === 0} animateOpacity>
            <Flex gap={5}>
              <Box flex={1}>
                <InputForm
                  name={responsible?.name}
                  label={responsible?.label}
                  placeholder={responsible?.placeholder}
                  isRequired
                  register={register}
                  errors={errors}
                />
              </Box>
              <Box flex={1}>
                <InputForm
                  name={responsibleEmail?.name}
                  label={responsibleEmail?.label}
                  placeholder={responsibleEmail?.placeholder}
                  isRequired
                  register={register}
                  errors={errors}
                />
              </Box>
              <Box flex={1}>
                <MaskedInputForm
                  name={responsiblePhone?.name}
                  label={responsiblePhone?.label}
                  placeholder={responsiblePhone?.placeholder}
                  isRequired
                  control={control}
                  errors={errors}
                  mask="(99) 99999-9999"
                />
              </Box>
              <Box flex={1}>
                <InputForm
                  name={responsibleFunction?.name}
                  label={responsibleFunction?.label}
                  placeholder={responsibleFunction?.placeholder}
                  isRequired
                  register={register}
                  errors={errors}
                  isReadOnly
                />
              </Box>
            </Flex>
          </Collapse>
        )}

        <Box mt={3} mb={4}>
          <Alert borderRadius="10px" status="info" variant="left-accent">
            <AlertIcon />
            <Box>
              <Text fontSize="sm">
                <Text as="span" fontWeight="bold">
                  Vincular responsáveis adicionais:
                </Text>{' '}
                Você pode buscar e vincular usuários existentes abaixo, ou ajustar permissões
                posteriormente na tela{' '}
                <Text
                  as="a"
                  href="/permissions/list"
                  color="blue.600"
                  fontWeight="bold"
                  textDecoration="underline"
                >
                  Permissões
                </Text>
                .
              </Text>
            </Box>
          </Alert>
        </Box>

        <Flex mr="auto">
          <FormButton
            mt={4}
            w="100px"
            isLoading={isSubmitting}
            type="submit"
            textTransform="uppercase"
          >
            Salvar
          </FormButton>
        </Flex>
      </form>
    </FormBox>
  );
}
